import { render, staticRenderFns } from "./OurTechHeader.vue?vue&type=template&id=77c586ef&"
import script from "./OurTechHeader.vue?vue&type=script&lang=js&"
export * from "./OurTechHeader.vue?vue&type=script&lang=js&"
import style0 from "./OurTechHeader.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports